import styled from "styled-components";
import { ModalBody as ReactstrapModalBody } from "reactstrap";
import SimpleBar from "simplebar-react";

export const ModalHeaderCreatPrompt = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 53px;
  background-color: #ccede9;
  padding: 0 20px;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    height: auto;
    padding: 10px 20px;
  }
`;

export const ModalHeaderTitle = styled.h4`
  display: flex;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  color: #495057;
  padding-top: 18px;
  font-weight: bold;

  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    padding-top: 13px;
  }
`;

export const ModalHeaderButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 24px;
  color: #495057;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const ModalBody = styled(ReactstrapModalBody)`
  display: flex;
  gap: 10px; /* Espaçamento entre as divs */
`;

export const TabContainer = styled.div`
  width: 40%;
`;
export const ContentContainer = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 15px;
`;

export const TextPrompt = styled.textarea`
  flex: 1;
  padding: 10px;
  border: 1px solid #e9ebec;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  resize: none;
  width: 100%;
  min-height: 300px;

  font-size: 14px;
  font-family: inherit;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  top: 18px;
  right: 20px;
`;

export const PromptBar = styled(SimpleBar)`
  width: 40%;
  max-height: 300px;
  border: 1px solid #e9ebec;
`;
